module.exports = __webpack_public_path__ + "img/indochine_singles_collection.67c59635.jpg";